// Copyright © 2021 Move Closer
import { BootstrapBadgeTheme } from './Badge.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapBadgeThemeClassRegistry = {
    [BootstrapBadgeTheme.Black]: '--black',
    [BootstrapBadgeTheme.Blue]: '--blue',
    [BootstrapBadgeTheme.Gray]: '--gray',
    [BootstrapBadgeTheme.Green]: '--green',
    [BootstrapBadgeTheme.Red]: '--red',
    [BootstrapBadgeTheme.White]: '--white',
    [BootstrapBadgeTheme.Yellow]: '--yellow'
};
